import { useGetUsageQuery } from '@/services/api/users-api'
import { IS_MOCK_AUTH } from '@/context/plan-constraint-utils'

/**
 * Remaining AI answer credits for the metered budget, or null when the user
 * has no metered budget (no usage data, or an unlimited/zero limit). One
 * source of truth for the credits line and the plus-menu footer.
 */
export function useAiCredits(): number | null {
  const { data: usage } = useGetUsageQuery(undefined, { skip: IS_MOCK_AUTH })
  const creditsLimit = usage?.ai_answer_credits_limit ?? 0
  return creditsLimit > 0 ? Math.floor(creditsLimit - (usage?.ai_answer_credits_used ?? 0)) : null
}
